module.exports = __webpack_public_path__ + "img/bg-rectangle-2.a7104f9c.svg";